// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7ed73881","455":"a2cae4ea","503":"a5d8e1ac","806":"02a77028","977":"d1107e7f"}[chunkId] + ".chunk.js";
};